<template>
  <wui-btn
    data-test="enable-button"
    :variant="modelValue ? 'positive' : 'neut'"
    state="alpha"
    icon
    prepend-icon="power"
    class="mx-1"
    @click="$emit('update:modelValue', !modelValue)"
  />
</template>
<script setup lang="ts">
import { WuiBtn } from '@wui/common-library'

defineProps<{
  modelValue: boolean
}>()

defineEmits<{
  (event: 'update:modelValue', value: boolean): void
}>()
</script>
